import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { useAppStore } from "../../stores/RootStore";
import { Separator } from "../../ui/Separator";
import DevicesGrid from "./DevicesGrid";

export const Devices = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const currentSite = useAppStore().currentSite
  const devices = useAppStore().devices;
  let device = devices?.find(n => n.id == id)

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full ">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}><span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span></NavLink>
          <span>/</span>
          {location.pathname == "/data/devices/" || location.pathname == "/data/devices" ? <span className="font-medium">{t("devices")}</span> : <NavLink to={"/data/devices"}><span className="font-medium">{t("devices")}</span></NavLink>}
          {(id || location.pathname == "/data/devices/new") && <span>/</span>}
          {id && <span>{device?.attributes.serial_number}</span>}
          {location.pathname == "/data/devices/new" && <span>{t('adding_devices')}</span>}
        </div>
      </div>
      <Separator className="flex-none"/>
      {id || location.pathname == "/data/devices/new" ? 
        <Outlet /> : 
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header name={t('devices')} backName={currentSite?.name ? currentSite?.name : "..."} backLink={"/"}/>
          <DevicesGrid onClose={empty}/>
        </div>
      }
    </div>
  )
};